export const HISTORY_DEFAULT_TIME_RANGE = 1;
export const HISTORY_TIME_RANGE_OPTIONS = [1, 3, 7];

/**
 * Cache key for a fetched column configuration.
 *
 * The backend returns `name: 'ALL'` for the transactions columns whatever location was asked for, so
 * keying the cache off the response body (as this slice used to) meant one location's captions were
 * served to every other location and to the all-locations grid, with no refetch. The key must carry
 * the location instead.
 *
 * Pass whatever `locationId` the caller has: a table with no location resolves to `:all`, which is
 * what the all-locations grid wants. Writer and reader derive the key the same way, so they cannot
 * disagree.
 */
export const configCacheKey = (configName, locationId) => `${configName}:${locationId ?? 'all'}`;

export const transactionTableConfig = {
    allLocationsTransactions: {
        dataUrlPath: (pageNum, size) => `/v2/transactions/trucks/recent?page=${pageNum}&size=${size}`,
        // No locationId: this grid spans locations, so there is no single correct caption. Defaults apply.
        configUrlPath: () => `/transactions/trucks/table/columns?type=Status`,
        configName: 'ALL',
        tableId: 'all_transactions',
    },
    // No configName: columns are per location, fetched by ensureHistoryColumnsConfig.
    singleLocationTransactions: {
        dataUrlPath: (pageNum, size, locationId) => `/v2/transactions/trucks/location/${locationId}?page=${pageNum}&size=${size}`,
        historyColumnsUrlPath: (locationId) => `/transactions/trucks/table/columns/${locationId}`,
    },

    singleLocationAnnouncements: {
        dataUrlPath: (pageNum, size, locationId) => `/transactions/trucks/announcement/location/${locationId}?page=${pageNum}&size=${size}`,
        // Announcement columns are out of scope for location-specific configuration.
        configUrlPath: () => `/transactions/trucks/table/announcements/table/columns`,
        configName: 'ANNOUNCEMENT',
    },

    allLocationsAnnouncements: {
        dataUrlPath: (pageNum, size) => `/transactions/trucks/announcement/location?page=${pageNum}&size=${size}`,
        searchUrlPath: (pageNum, size) => `/transactions/trucks/announcement/location?page=${pageNum}&size=${size}`,
        searchMethod: 'get',
        configUrlPath: () => `/transactions/trucks/table/announcements/table/columns/all`,
        configName: 'ANNOUNCEMENT_ALL',
        tableId: 'all_announcements',
    },
};

// Maps a tableId to its transactionTableConfig entry key.
export const getTableConfigByTableId = (tableId) => Object.values(transactionTableConfig).find((config) => config.tableId === tableId) || null;
